import { Component } from "@/decorators";
import ProdutoDciModel from "@/models/produto/produtoDciModel";
import produtoDciService from "@/services/produto/produtoDciService";

import EditComponentBase from "../editComponentBase";

@Component
export default class ProdutoDciEditComponent extends EditComponentBase<ProdutoDciModel> {
    private async beforeMount() {
        await this.setPropsCached(produtoDciService, "dcis", new ProdutoDciModel());
    }
}
